const adminCart = {
  id: "cart_admin_1",
  ownerUserId: "admin_self",
  updatedAt: "2025-06-22T10:00:00Z",
  currency: "USD",
  items: [
    {
      id: "ci_1",
      sku: "WWG-TS-BLK-M",
      productId: "prd_1001",
      variationId: "var_1",
      quantity: 2,
      unitPriceCents: 2500,
    },
    {
      id: "ci_2",
      sku: "WWG-MUG-WHT",
      productId: "prd_1002",
      variationId: null,
      quantity: 1,
      unitPriceCents: 1200,
    },
  ],
  subtotalCents: 6200,
};

export default adminCart;
